<div class="section-header" mat-dialog-title>
    <mat-icon class="section-icon">touch_app</mat-icon>
    <span class="section-title">{{ 'ai.linkToSlide' | transloco }}</span>
    <button mat-icon-button class="ss-dialog-close-btn" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<div mat-dialog-content>
    <div style="margin-bottom: 10px;">{{ 'ai.whatDoYouWantToMoveSlideWhenClickButton' | transloco }}</div>
    <mat-radio-group
        aria-labelledby="slide button command"
        class="command-radio-group"
        [(ngModel)]="selectedCommand"
        (change)="onCommandChange($event)">
        @for (command of commandList; track command) {
            <mat-radio-button [value]="command.value">{{ command.name }}</mat-radio-button>
        }
    </mat-radio-group>

    <!-- Custom Button Text for all options -->
    @if (newTouchButton) {
        <div class="custom-text-section">
            <mat-form-field appearance="outline" class="custom-text-field">
                <mat-label>{{ 'ai.buttonTextOptional' | transloco }}</mat-label>
                <textarea
                    matInput
                    [(ngModel)]="customButtonText"
                    [placeholder]="getPlaceholderText()"
                    rows="2"
                    maxlength="50">
                </textarea>
                <mat-hint>{{ getHintText() }}</mat-hint>
            </mat-form-field>
        </div>
    }

    <!-- View Toggle Controls - Always Show -->
    <div class="view-controls">
        <div class="view-toggle-group">
            <button
                mat-icon-button
                [class.active]="viewMode === 'grid'"
                (click)="setViewMode('grid')"
                [matTooltip]="'ai.gridView' | transloco">
                <mat-icon>grid_view</mat-icon>
            </button>
            <button
                mat-icon-button
                [class.active]="viewMode === 'list'"
                (click)="setViewMode('list')"
                [matTooltip]="'ai.listView' | transloco">
                <mat-icon>view_list</mat-icon>
            </button>
        </div>

        <!-- Search and Filter -->
        <div class="search-controls">
            <mat-form-field appearance="outline" class="search-field">
                <mat-label style="position: relative; top: -5px">{{ 'ai.searchSlides' | transloco }}</mat-label>
                <input matInput [(ngModel)]="searchTerm" (input)="onSearchChange()"
                        [placeholder]="'ai.searchByNameOrIndex' | transloco">
                <mat-icon matPrefix>search</mat-icon>
                @if (searchTerm) {
                    <button matSuffix mat-icon-button (click)="clearSearch()">
                        <mat-icon>clear</mat-icon>
                    </button>
                }
            </mat-form-field>
        </div>
    </div>

    <!-- Grid View - Always Show -->
    @if (viewMode === 'grid') {
        <div class="preview-slides-grid"
             [class.large-dataset]="filteredSlideList.length > 20"
             [class.disabled-previews]="selectedCommand !== 'selectPage'">
            <div class="grid-container" cdkScrollable>
                @for (slide of filteredSlideList; track slide.sceneId; let i = $index) {
                    <div
                        class="preview-slide-card"
                        [class.selected]="linkSlideSceneId === slide.sceneId"
                        [class.disabled]="selectedCommand !== 'selectPage'"
                        (click)="selectSlideToLink(slide.sceneId)">
                        <div class="slide-preview">
                            <app-scene-preview
                                [setSelectedSceneId]="slide.sceneId"
                                [setSceneWidth]="width"
                                [setSceneHeight]="height"
                                [previewHeight]="previewHeight"
                                [autoScale]="true"
                                [autoZoom]="false">
                            </app-scene-preview>
                        </div>
                        <div class="slide-info">
                            <div class="slide-name">{{ slide.title || 'Slide ' + (i + 1) }}</div>
                            <div class="slide-index">#{{ i + 1 }}</div>
                        </div>
                        <div class="selection-indicator">
                            <mat-icon>check_circle</mat-icon>
                        </div>
                    </div>
                }
            </div>
        </div>
    }

    <!-- List/Datagrid View - Always Show -->
    @if (viewMode === 'list') {
        <div class="preview-slides-list" [class.disabled-previews]="selectedCommand !== 'selectPage'">
            <div class="slide-count-info">
                <span class="slide-count">{{ filteredSlideList.length }} {{ 'ai.slides' | transloco }}</span>
            </div>
            <div class="list-header">
                <div class="col-preview">{{ 'ai.preview' | transloco }}</div>
                <div class="col-name">{{ 'ai.name' | transloco }}</div>
                <div class="col-index">{{ 'ai.index' | transloco }}</div>
                <div class="col-size">{{ 'ai.size' | transloco }}</div>
                <div class="col-action">{{ 'ai.action' | transloco }}</div>
            </div>
            <div class="list-container" cdkScrollable>
                @for (slide of filteredSlideList; track slide.sceneId; let i = $index) {
                    <div
                        class="list-row"
                        [class.selected]="linkSlideSceneId === slide.sceneId"
                        [class.disabled]="selectedCommand !== 'selectPage'"
                        (click)="selectSlideToLink(slide.sceneId)">
                        <div class="col-preview">
                            <div class="mini-preview">
                                <app-scene-preview
                                    [setSelectedSceneId]="slide.sceneId"
                                    [setSceneWidth]="width"
                                    [setSceneHeight]="height"
                                    [previewHeight]="40"
                                    [autoScale]="true"
                                    [autoZoom]="false">
                                </app-scene-preview>
                            </div>
                        </div>
                        <div class="col-name">
                            <div class="slide-name">{{ slide.title || 'Slide ' + (i + 1) }}</div>
                            <div class="slide-id">ID: {{ slide.sceneId }}</div>
                        </div>
                        <div class="col-index">
                            <span class="index-badge">#{{ i + 1 }}</span>
                        </div>
                        <div class="col-size">
                            <span class="size-info">{{ width }} x {{ height }}</span>
                        </div>
                        <div class="col-action">
                            <button
                                mat-icon-button
                                color="primary"
                                [disabled]="linkSlideSceneId === slide.sceneId || selectedCommand !== 'selectPage'"
                                (click)="selectSlideToLink(slide.sceneId); $event.stopPropagation()">
                                <mat-icon>{{ linkSlideSceneId === slide.sceneId ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                            </button>
                        </div>
                    </div>
                }
            </div>
        </div>
    }

    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="32px" style="margin-top: 30px;">
        <button mat-raised-button color="warn" (click)="onAddTouchAction()" style="min-width: 100px;" [disabled]="selectedCommand === 'selectPage' && !linkSlideSceneId">
            @if (newTouchButton) {
                {{ 'general.add' | transloco }}
            } @else {
                {{ 'general.ok' | transloco }}
            }
        </button>

        <button mat-raised-button color="primary" (click)="closeModal()" style="min-width: 100px;">
            {{ 'general.cancel' | transloco }}
        </button>
    </div>
</div>
